var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01457 0.297212C8.949 0.304296 8.88775 0.333308 8.84073 0.379548L1.49447 7.7304C1.45089 7.77379 1.42207 7.8298 1.41212 7.89049L1.10107 9.85742C1.09407 9.90288 1.09788 9.94935 1.11218 9.99306C1.12649 10.0368 1.15089 10.0765 1.18341 10.109C1.21593 10.1415 1.25566 10.1659 1.29937 10.1802C1.34307 10.1945 1.38954 10.1983 1.435 10.1913L3.40193 9.88029C3.46208 9.87162 3.51803 9.84444 3.56204 9.80253L10.9129 2.45169C10.9404 2.42447 10.9622 2.39205 10.9772 2.35632C10.9921 2.3206 10.9997 2.28227 10.9997 2.24356C10.9997 2.20485 10.9921 2.16652 10.9772 2.1308C10.9622 2.09507 10.9404 2.06266 10.9129 2.03543L9.257 0.379548C9.22546 0.348358 9.18725 0.324733 9.14526 0.31047C9.10326 0.296206 9.05857 0.291677 9.01457 0.297212ZM9.04658 1.00165L10.2908 2.24585L9.77388 2.76274L8.52968 1.51854L9.04658 1.00165ZM8.11343 1.9348L9.35763 3.179L3.56204 8.97459L2.31784 7.7304L8.11343 1.9348ZM1.95646 8.19239L3.10003 9.33596L1.74146 9.55095L1.95646 8.19239Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.287587
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.62213,
    y1: 12.1801,
    x2: 10.2844,
    y2: 12.1801,
    stroke: "#43927C",
    strokeWidth: 1.04992,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a66f5ceda008cf1d95302b046b33cbc7.svg";
export { ForwardRef as ReactComponent };